import React from "react";
import { Route, Switch } from "react-router-dom";
import RoleRoute from "../components/RoleRoute";
import { roles } from "../misc/enumerations";
import {
  NotificationContainer,
} from "react-notifications";
import Content from "./content";
import Dashboard from "./dashboard";
import Categories from "./settings/categories";
import CategoryForm from "./settings/categoryForm";
import Menu from "./menu";
import Item from "./item";
import ItemForm from "./item/itemForm";
import Setting from "./setting";
import URLRedirects from './URLRedirects/';
import Blogs from './blogs';
import BlogForm from './blogs/blogForm';
import Images from './images';
import Popups from "./popups";
import Ads from "./ads";
import Users from './users';
import UserForm from './users/userForm';
import DownloadSettings from "./downloadSettings";
import ZipFiles from "./zipFiles";
import Staff from "./staff";
import SchoolAdminDashboard from "./SchoolAdminDashboard";
import Schools from "./schools";
// import Form from "./staff/form";

const App = ({ match }) => (
  <div className="gx-main-content-wrapper">
    <NotificationContainer />
    <Switch>
      {/* <Route path={`${match.url}dashboard`} component={Dashboard} />
      <Route path={`${match.url}content-keys`} component={Content} />
      <Route path={`${match.url}menu`} component={Menu} />
      <Route path={`${match.url}item`} component={Item} />
      <Route path={`${match.url}itemForm`} component={ItemForm} />
      <Route path={`${match.url}itemEditForm/:id`} component={ItemForm} />
      <Route path={`${match.url}categories`} component={Categories} />
      <Route path={`${match.url}categoryForm`} component={CategoryForm} />
      <Route path={`${match.url}categoryEditForm/:id`} component={CategoryForm} />
      <Route path={`${match.url}setting`} component={Setting} />
      <Route path={`${match.url}url-redirects`} component={URLRedirects} />
      <Route path={`${match.url}blogs`} component={Blogs} />
      <Route path={`${match.url}blogForm`} component={BlogForm} />
      <Route path={`${match.url}blogEditForm/:id`} component={BlogForm} />
      <Route path={`${match.url}images`} component={Images} />
      <Route path={`${match.url}popups`} component={Popups} />
      <Route path={`${match.url}users`} component={Users} />
      <Route path={`${match.url}userForm`} component={UserForm} />
      <Route path={`${match.url}userEditForm/:id`} component={UserForm} />
      <Route path={`${match.url}downloadSettings`} component={DownloadSettings} />
      <Route path={`${match.url}zipFiles`} component={ZipFiles} />
      <Route path={`${match.url}staff`}  component={Staff} /> */}
      {/* <Route path={`${match.url}staff/form`} component={Form} /> */}
 <RoleRoute
    path={`${match.url}dashboard`}
    component={Dashboard}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}content-keys`}
    component={Content}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}menu`}
    component={Menu}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}item`}
    component={Item}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}itemForm`}
    component={ItemForm}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}itemEditForm/:id`}
    component={ItemForm}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}categories`}
    component={Categories}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}categoryForm`}
    component={CategoryForm}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}categoryEditForm/:id`}
    component={CategoryForm}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}setting`}
    component={Setting}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}url-redirects`}
    component={URLRedirects}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}blogs`}
    component={Blogs}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}blogForm`}
    component={BlogForm}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}blogEditForm/:id`}
    component={BlogForm}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}images`}
    component={Images}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}popups`}
    component={Popups}
    allowedRoles={[roles.Admin]}
  />
  <RoleRoute
    path={`${match.url}ads`}
    component={Ads}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}users`}
    component={Users}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}userForm`}
    component={UserForm}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}userEditForm/:id`}
    component={UserForm}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}downloadSettings`}
    component={DownloadSettings}
    allowedRoles={[roles.Admin]}
  />

  <RoleRoute
    path={`${match.url}zipFiles`}
    component={ZipFiles}
    allowedRoles={[roles.Admin]}
  />
  <RoleRoute
    path={`${match.url}schools`}
    component={Schools}
    allowedRoles={[roles.Admin]}
  />
      <RoleRoute
        path={`${match.url}staff`}
        component={Staff}
        allowedRoles={[roles.SchoolAdmin]}
      />
      <RoleRoute
        path={`${match.url}schooladmindashboard`}
        component={SchoolAdminDashboard}
        allowedRoles={[roles.SchoolAdmin]}
      />
    </Switch>
  </div>
);

export default App;
